<template>
    <div>
        <b-row v-if="!isRerequest">
            <b-col
                cols="12"
                lg="8"
                class="mb-5"
            >
                <p>In order to successfully register your property, we require you, by law, to complete an AML (Anti Money Laundering) check. Please click the button below and follow the instructions.</p>
            </b-col>
        </b-row>

        <button
            :disabled="inProgress || isRerequest"
            :class="{ 'disabled': inProgress || isRerequest }"
            class="btn btn--primary mr-3"
            @click.prevent="getAmlCheck()"
        >
            {{ disableAml || user.aml_requested ? 'AML check already requested' : 'AML Check' }}
        </button>

        <button
            v-if="isRerequest"
            :disabled="inProgress"
            :class="{ 'disabled': inProgress }"
            class="btn btn--secondary"
            @click.prevent="getAmlCheck(true)"
        >
            Re-request AML Check
        </button>

        <!-- AML check modal -->
        <b-modal
            id="modal-aml-check"
            ref="modalCheck"
            title=""
            size="md"
            hide-footer
        >
            <SVGSprite
                name="credas"
                class="credas-logo"
            />
            <h2 class="text-bold color-white text-uppercase mb-4">
                Credas makes identity verification simple
            </h2>
            <p
                v-if="rerequest"
                class="text-bold color-primary"
            >
                Please make sure your mobile telephone number is correct and has been saved before rerequesting an AML check.
            </p>
            <p>Before we can check the listing you have supplied and publish the property live, you will need to complete the Anti Money Laundering verification.</p>
            <p>This is a legal requirement and our independent partner providing this confidential service is Credas. Credas will communicate with you by SMS messaging using the mobile number you have input into your profile.</p>
            <p>Please click the button below to send the required information to our partner service to begin the process. There will be a checking period of up to 24 hours whilst the AML is checked and processed.</p>

            <p class="text-bold color-secondary mt-5">
                *In order to complete your AML check, ensure you have entered a phone number in your profile details
            </p>
            <div class="d-flex flex-column mt-5">
                <button
                    :disabled="inProgress"
                    :class="{ 'disabled': inProgress }"
                    type="button"
                    class="btn btn--secondary mb-3"
                    @click="processAmlCheck"
                >
                    Complete AML Check
                </button>
                <a
                    href="/storage/documents/Credas_Mobile_App_User_Guide.pdf"
                    class="btn btn--primary"
                    target="_blank"
                >
                    Download AML User Guide
                </a>
            </div>
        </b-modal>
        <!-- END AML check modal -->
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'AMLCheck',
    data() {
        return {
            disableAml: false,
            rerequest: false,
            inProgress: false
        };
    },
    computed: {
        ...mapState('user', ['user']),
        isRerequest() {
            return this.disableAml || this.user.aml_requested;
        }
    },
    methods: {
        ...mapActions('user', ['submitAmlCheck', 'refreshUser']),
        getAmlCheck(rerequest = false) {
            if (rerequest) {
                this.rerequest = true;
            }

            this.$refs.modalCheck.show();
        },
        processAmlCheck() {
            if (this.user.mobile_telephone) {
                this.inProgress = true;

                this.submitAmlCheck()
                    .then(() => {
                        this.disableAml = this.rerequest = true;
                        this.$toasted.success('Your AML check request has been successfully submitted');
                        this.refreshUser();
                        this.$refs.modalCheck.hide();
                        this.inProgress = false;
                    })
                    .catch(() => {
                        this.$toasted.error('There was a problem while attempting to submit your AML check. Please try again later or contact us if this error persists.');
                        this.inProgress = false;
                    });
            }
            else {
                this.$toasted.error('You need to add a mobile telephone number and save your profile before an AML check can be submitted');
            }
        }
    }
};
</script>

<style lang="scss">
.modal {
    &#modal-aml-check {
        .modal-dialog {
            .modal-content {
                background: #00152d;
                text-align: center;
            }

            .modal-header {
                background: #00152d;
                color: white;
                text-transform: uppercase;
                padding: 2rem 4rem;

                .modal-title {
                    margin: 0 auto;
                }
            }

            .modal-body {
                padding-top: 0;

                p {
                    color: white;
                }
            }
        }
    }
}
</style>
